/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Grower_Payment_Delete_SuccessInputs */

const vi_toast_grower_payment_delete_success = /** @type {(inputs: Toast_Grower_Payment_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá phiếu chuyển khoản`)
};

/**

* @param {Toast_Grower_Payment_Delete_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_grower_payment_delete_success = /** @type {((inputs?: Toast_Grower_Payment_Delete_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Grower_Payment_Delete_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_grower_payment_delete_success(inputs)
});